export default {"src":"__ASTRO_ASSET_IMAGE__Bw5nu5Es__","width":569,"height":570,"format":"svg"}